import { module } from "../app";
import { safeApply } from "../services/safeApply";

module.directive("dropdownMenuOld", function ($rootScope, $window) {
  return {
    restrict: "E",
    templateUrl: "views/templates/dropDownOld.html",
    scope: {
      placeholder: "@",
      list: "=",
      selected: "=",
      onSelectionChange: "&",
      selectMode: "=",
      property: "@",
      key: "@",
      displayProperty: "@?",
      icon: "@",
      hideOtherDropdown: '=?',
      dropdownHeight: '=?',
      showCaret: '=?',
      alwaysPlaceholder: '=?',
      boldPlaceholder: '=?',
      allowClean: '=?'
    },
    link: function (scope, element) {
      scope.listVisible = false;
      scope.isPlaceholder = true;
      scope.isDropdownMenu = true;
      scope.showToTheTop = false;
      scope.dropdownHeight = scope.dropdownHeight || 300;

      if (scope.allowClean) {
        let placeholderOption = {}
        placeholderOption[ scope.key ] = '';
        placeholderOption[ scope.property ] = scope.placeholder;
        scope.list.unshift(placeholderOption);
      }

      let firstPart = Math.random().toString(36).substring(7);
      const className = firstPart + "-dropdown-menu-" + new Date().getTime();

      $(element).addClass(className);

      scope.select = function (item) {
        if (item.separator || (item.Value && (item.Value.indexOf('---') > -1 || item.Value.indexOf('\\-') > -1))) {
          return;
        }

        if (scope.selectMode) {
          scope.selected = item[ scope.key ];
        }

        if (scope.displayProperty) {
          scope.display = item[ scope.displayProperty ];
          //scope.isPlaceholder = false;
        } else {
          //scope.isPlaceholder = true;
          scope.display = item[ scope.property ];
        }

        let cb = scope.onSelectionChange;
        if (cb) {
          cb({$type: item[ scope.key ]});
        }
      };

      scope.isSelected = function (item) {
        if (scope.selected instanceof Array) {
          return (scope.selected.filter(selectedItem => selectedItem.Code === item[ scope.key ]).length > 0);
        }
        return scope.selected && item[ scope.key ] && item[ scope.key ].toString() === scope.selected.toString();
      };

      scope.watchObject = scope.$watch('selected', (newVal, oldVal) => {
        if (newVal === undefined || newVal === null || !scope.list)
          return;

        let selectedItem = scope.list.find(item => item[ scope.key ] === newVal || item[ scope.key ].toString() === newVal.toString());

        if (selectedItem && !scope.alwaysPlaceholder) {
          if (scope.displayProperty) {
            scope.display = selectedItem[ scope.displayProperty ];
            //scope.isPlaceholder = false;
          } else {
            //scope.isPlaceholder = true;
            scope.display = selectedItem[ scope.property ];
          }
          scope.isPlaceholder = false;
        }
        else {
          scope.isPlaceholder = true;
        }
      });

      scope.toggle = function (e) {
        e.stopPropagation();
        safeApply(scope, () => {
          scope.listVisible = !scope.listVisible;
          if (scope.listVisible) {
            scope.checkDropdownFit();
          }
          scope.hideOtherDropdown = !!scope.listVisible;
          if (!scope.listVisible) {
            scope.watchObject();
          }
        });
      };

      scope.checkDropdownFit = function () {

        const el = element.find('.scroll')[ 0 ];

        const hight = el.clientHeight;
        let top = 0;
        let scroll = 0;

        let e = el;
        do {
          top += (e.offsetTop + e.clientTop);
          e = e.offsetParent;
          //console.log('e.offsetParent', e.offsetParent.className);
        }
        while (e.offsetParent && e.offsetParent.className.indexOf('modal-form') === -1 && e.parentElement.className.indexOf('modal') === -1);

        e = el;
        do {
          scroll += e.scrollTop;
          e = e.parentElement;
          //console.log('e.parentElement', e.parentElement.className);
        }
        while (e.parentElement && e.parentElement.className.indexOf('modal-form') === -1 && e.parentElement.className.indexOf('modal') === -1);

        let totalHeight = $window.innerHeight;
        if (e.parentElement && e.parentElement.className && e.parentElement.className.indexOf('modal-form') === -1 && e.parentElement.className.indexOf('modal') === -1) {
          totalHeight = e.parentElement.clientHeight;
        }

        // distance from dropdown (bottom-left point) to the bottom of the window
        const bottom = totalHeight - ((top + hight) - scroll);
        const footerHight = 100;
        scope.showToTheTop = bottom < footerHight;
      };

      scope.$on("documentClicked", function (inner, e) {
        const target = e.target;
        if (
          $(target).is("." + className) ||
          $(target).closest("." + className).length
        ) {
          e.stopPropagation();
          return;
        }

        safeApply(scope, () => {
          scope.listVisible = false;
          scope.hideOtherDropdown = false;
        });
      });
    }
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/dropdownMenu-old.js